var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMrchart = function SvgMrchart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 78 78"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "#fff",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M34 27.334h-3.333a3.333 3.333 0 0 0-3.334 3.333v20A3.333 3.333 0 0 0 30.667 54h16.666a3.333 3.333 0 0 0 3.334-3.333v-20a3.333 3.333 0 0 0-3.334-3.334H44m-10 0a3.333 3.333 0 0 0 3.333 3.334h3.334A3.333 3.333 0 0 0 44 27.333m-10 0A3.333 3.333 0 0 1 37.333 24h3.334A3.333 3.333 0 0 1 44 27.334M39 39h5m-5 6.667h5M34 39h.017M34 45.667h.017"
  })));
};
export default SvgMrchart;